import { getCheckoutUrlBasedOnEnv } from "../helpers";
import { ENV, MessageType } from "../types";

type Subscriber = {
  eventName: string;
  callerName: string;
  callback: () => void;
};

export function startListener(env: ENV, customCheckoutUrl?: string) {
  const inPageStatusSubscribers: Array<Subscriber | null> = [];

  const listener = (event: MessageEvent<any>) => {
    // Handle messages only if origin is correct.
    if (event.origin !== getCheckoutUrlBasedOnEnv(env, customCheckoutUrl)) {
      return false;
    }

    if (event.data.from !== "checkout") {
      return false;
    }

    if (event.data.type === "in_page_status") {
      inPageStatusSubscribers
        .filter(
          (subscriber) => subscriber && subscriber.eventName === event.data.payload
        )
        .forEach((subscriber) => {
          subscriber && subscriber.callback();
        });
    } else if (
      // Sent by the iframe fallback, see Embedded/fallback.ts
      event.data.type !== "embedded_height" &&
      event.data.type !== "translations"
    ) {
      console.warn("Unknown message type:", event.data.type);
    }
  };

  window.addEventListener("message", listener, false);

  function unsubscribe() {
    window.removeEventListener("message", listener, false);
  }

  function onInPageStatusChanged(
    eventName: MessageType,
    callerName: string,
    callback: () => void
  ) {
    const previousIndex = inPageStatusSubscribers.findIndex(
      (subscriber) =>
        subscriber &&
        subscriber.eventName === eventName &&
        subscriber.callerName === callerName
    );

    if (previousIndex !== -1) {
      inPageStatusSubscribers[previousIndex] = null;
    }

    inPageStatusSubscribers.push({ eventName, callerName, callback });
  }

  return {
    onInPageStatusChanged,
    unsubscribe,
  };
}
